import "./styles.sass";
import classNames from "classnames";

type NotificationCircleProps = {
  className?: string;
};

const NotificationCircle = ({ className }: NotificationCircleProps) => {
  return (
    <div className={classNames("NotificationCircle", className)}>
      <div className="NotificationCircle__after" />
    </div>
  );
};

export default NotificationCircle;
